import { ActionReducerMap } from '@ngrx/store';
import * as fromNew from './+stories/new/store/new.reducer';
import * as fromShared from './shared/shared.reducer';

export interface AppState {
  new: fromNew.State;
  shared: fromShared.State;
}

export const appReducer: ActionReducerMap<AppState> = {
  new: fromNew.NewReducer,
  shared: fromShared.SharedReducer
};
